import { RouteObject } from 'react-router';
import { Outlet } from 'react-router-dom';

import { SHOP_CURRENT_ROUTE } from '../../utils/constants';
import { LegalPage } from './pages/LegalPage';

const routes: RouteObject[] = [
    {
        path: `${SHOP_CURRENT_ROUTE}/legal`,
        element: <Outlet />,
        children: [
            {
                index: true,
                element: <LegalPage />,
            },
        ],
    },
];
export default routes;
